import './App.css';
import {
	BrowserRouter as Router,
	Routes,
	Route,
	Navigate,
} from 'react-router-dom';
import NoMatch from './components/Four0Four';
import Profile from './components/Profile';
import Notifications from './components/Notifications';
import ArchivedNotifications from './components/ArchivedNotifications';
import QAForum from './components/QAForum';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsOfServices from './components/TermsOfServices';
import Review from './components/Review';
import Subscription from './components/Subscription';
import Login from './components/Login';
import { Routess } from './config/Routes';
import Stripe from './components/stripe.jsx';

import { useSelector } from 'react-redux';

function App() {
	const profile = useSelector(state => state.auth.profile);
	var userType = '';
	var routeComponents = '';
	if (!profile) {
		routeComponents = Routess['public'].map(({ path, element }, key) => (
			<Route exact path={path} element={element} key={key} />
		));
		// return <Routess> {routeComponents} </Routess>;
	} else {
		userType = profile?.user?.user_type;
	}

	if (profile) {
		routeComponents = Routess[userType.toLowerCase()].map(
			({ path, element }, key) => {
				return <Route exact path={path} element={element} key={key} />;
			}
		);
	}
	
	return (
		<Router>
			<Routes>
				{routeComponents}
				<Route path='/profile' element={<Profile />} />
				<Route path='/notifications/:id' element={<Notifications />} />
				<Route
					path='/archived-notifications'
					element={<ArchivedNotifications />}
				/>
				<Route path='/qa-forum' element={<QAForum />} />
				<Route path='/privacy-policy' element={<PrivacyPolicy />} />
				<Route path='/terms-of-services' element={<TermsOfServices />} />
				<Route path='/review' element={<Review />} />
				<Route path='/subscribe' element={<Subscription />} />
				<Route path='/stripe' element={<Stripe />} />
				<Route
					path='/login'
					element={profile ? <Navigate to='/' /> : <Login />}
				/>
				<Route path='*' element={<NoMatch />} />
			</Routes>
		</Router>
	);
}

export default App;
